// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"oF","carousel__wrapper_on_sides":"pF","arrows_wrapper":"qF","arrows_wrapper_right":"rF","arrows_wrapper_vertical":"sF","arrows_wrapper_on_sides":"tF","arrow_button":"uF","carousel_arrow_left":"vF","carousel_arrow_left_on_side":"wF","carousel_arrow_right_on_side":"xF","carousel_arrow":"yF","arrows_wrapper_rounded":"zF","carousel__fullWidth":"AF"};
    if(module.hot) {
      // 1715632477985
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  